const findEmptyStateCategory = (loading, columns, data) => {
  if (loading) return "loading";
  if (columns && columns.filter(c => !c.hideIfOnlyColumn).length === 0) return "emptyColumns";
  if (data && data.length === 0) return "emptyData";
  return null;
};

export { findEmptyStateCategory };
